import * as React from "react";
import { useAppointmentContext } from "../../../pages/BookAppointment/context/v3/pages/BookAppointment/context/AppointmentContext.js";
import useVirtualAppointment from "../../../pages/BookAppointment/hooks/v3/pages/BookAppointment/hooks/use-virtual-appointment.js";
const useDataLayerInput = () => {
  const [{ isVirtualAppointmentType }] = useVirtualAppointment();
  const [, { timeSlot, type, store }] = useAppointmentContext();
  return React.useMemo(
    () => ({
      store: store && !isVirtualAppointmentType(type) ? store : void 0,
      appointment: type ? {
        appointmentType: {
          id: type.id,
          isVirtualAppointment: isVirtualAppointmentType(type),
          ageGroup: type.ageGroup
        },
        startTime: timeSlot?.from,
        endTime: timeSlot?.until
      } : void 0
    }),
    [isVirtualAppointmentType, store, timeSlot?.from, timeSlot?.until, type]
  );
};
export {
  useDataLayerInput as default
};
//# sourceMappingURL=use-data-layer-input.js.map
